<template>
    <div class="footer-wrap">
        <div class="contact">
            <!-- 版心区域 -->
            <div class="wrapper flex-middle-center">
                <div>
                    ◎ 2025上海晨光文具股份有限公司
                </div>
                <img src="./image/badge-icon.png" alt="">
                <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank" rel="noopener noreferrer">沪公网安备31012002003064号</a> &nbsp;| &nbsp;
                <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener noreferrer">沪ICP备05010720号-7</a>
            </div>
        </div>
    </div>
</template>


<style lang="scss" scoped>
.contact{
    height: 52px;
    background: #333333;
    font-weight: 400;
    font-size: 14px;
    color: #B3B3B3;
    line-height: 21px;
    display: flex;
    align-items: center;
    .wrapper{
        a{
             color: #B3B3B3;
        }
        img{
            width: 18px;
            height: 18px;
            margin: 0 4px;
        }
    }
}
</style>